import './floating-nav.css';
import data from './data';
import { useEffect, useState } from 'react';

const FloatingNav = () => {

const [activeSection, setActiveSection] = useState('#home');
const [showFloatingNav, setShowFloatingNav] = useState(false);

useEffect(() => {

  const sections = data.map(item => document.querySelector(item.link)).filter(Boolean);

  const observer = new IntersectionObserver((entries) =>{
    
      entries.forEach((entry) => {
        if(entry.isIntersecting){
          setActiveSection(`#${entry.target.id}`)
        }
      })
  },
  {
    threshold: 0.5,
  }
)
    sections.forEach((section) =>{
      observer.observe(section)
    })

    return() => {
      observer.disconnect();
    }
},[])

console.log("Active section:", activeSection);

useEffect(() =>{

    const handleScroll = () => {
      if(window.scrollY > 300) {
        setShowFloatingNav(true);
      } 
      else{
        setShowFloatingNav(false);
      }
    }

    window.addEventListener('scroll',handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
}, [])

  return (
    <div className= {`floating__nav ${showFloatingNav ? 'show' : ''}`}>
      {
        data.map(item => (
          <a key={item.id} 
             href= {item.link} 
             className= {activeSection === item.link ? 'active' : ''}
             aria-label={item.title}
             >
             {item.icon}
          </a>
        ))
      }
    </div>
  )
}

export default FloatingNav